import React from 'react';
import { motion } from 'framer-motion';
import { isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Icons from '../layouts/Icons';
import Link from '../layouts/Link';

export default function FooterMobileMenu({ data, lightLogo }) {
  return (
    <div className="sm:hidden flex flex-col pt-[90px] pb-[55px] gap-y-[40px]">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.3 }}
        viewport={{ once: true }}>
        <Link to="/">
          {isEmpty(lightLogo) || <LazyLoadImage src={lightLogo.url} className="w-[190px] h-auto" />}
        </Link>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.3 }}
        viewport={{ once: true }}
        className="flex flex-wrap gap-x-[15px] gap-y-[30px] w-full justify-between">
        {isEmpty(data) ||
          data.map(
            (item, index) =>
              item?.content?.urls && (
                <div key={index} className="flex flex-col w-auto gap-y-[10px]">
                  {item.content.urls.map((itemLinks, index) => (
                    <Link
                      to={itemLinks.url}
                      key={index}
                      className="text-white text-[12px] font-roboto-regular">
                      {itemLinks.name}
                    </Link>
                  ))}
                </div>
              ),
          )}
      </motion.div>
    </div>
  );
}
